import axiosConfig from "./axiosConfig";

export interface DownloadZipRequest {
  guids: string[];
}

export interface DownloadZipResponse {
  downloadUrl: string;
  fileName: string;
  fileCount: number;
  totalSizeBytes: number;
}

const postHhDataDownloadZip = async (
  authToken: string,
  request: DownloadZipRequest
): Promise<DownloadZipResponse> => {
  const { data } = await axiosConfig.post("/hh_data/download_zip", request, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default postHhDataDownloadZip;
